module.exports = __webpack_public_path__ + "img/65a1a25.jpeg";